/* tslint:disable */
import {
  LotQualityAnalysis
} from '../index';

declare var Object: any;
export interface LotQualityAnalysisImageInterface {
  "id"?: number;
  "name"?: string;
  "image"?: string;
  "analysis_id"?: number;
  analysis?: LotQualityAnalysis;
}

export class LotQualityAnalysisImage implements LotQualityAnalysisImageInterface {
  "id": number;
  "name": string;
  "image": string;
  "analysis_id": number;
  analysis: LotQualityAnalysis;
  constructor(data?: LotQualityAnalysisImageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LotQualityAnalysisImage`.
   */
  public static getModelName() {
    return "LotQualityAnalysisImage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LotQualityAnalysisImage for dynamic purposes.
  **/
  public static factory(data: LotQualityAnalysisImageInterface): LotQualityAnalysisImage{
    return new LotQualityAnalysisImage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LotQualityAnalysisImage',
      plural: 'LotQualityAnalysisImages',
      path: 'LotQualityAnalysisImages',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "analysis_id": {
          name: 'analysis_id',
          type: 'number'
        },
      },
      relations: {
        analysis: {
          name: 'analysis',
          type: 'LotQualityAnalysis',
          model: 'LotQualityAnalysis',
          relationType: 'belongsTo',
                  keyFrom: 'analysis_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LotQualityAnalysisImage.ts